module.exports = __webpack_public_path__ + "img/SQLark-app.6d494cda.svg";